import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ImageValidatorService = {
    getValidation: (formData, config) => axios.post(API_URL + "/imageValidator/validation", formData, config).then(({ data }) => data).catch((err) => { throw err }),
};

export default ImageValidatorService;